module.exports = __webpack_public_path__ + "static/Icon3-71a2d5057d4358e729f0a2c09a16f7f6.svg";